//
// IMPORTANT: This file is a schema and must be managed with extreme care.
// See types/schema/README.md for more information.
//

import { z } from 'zod'

/**
 * View type options for allocation list
 */
export enum ViewType {
  Standard = 'Standard',
  Compact = 'Compact',
}

const viewTypeSchema = z.nativeEnum(ViewType)

/**
 * Schema for allocation list configuration
 */
const allocationListConfigSchema = z.object({
  viewType: viewTypeSchema.default(ViewType.Standard),
})

/**
 * Type definition for allocation list configuration
 */
export type AllocationListConfig = z.infer<typeof allocationListConfigSchema>

/**
 * Default allocation list configuration
 */
export const defaultAllocationListConfig: AllocationListConfig = {
  viewType: ViewType.Standard,
}
